import {Component, forwardRef, OnInit} from '@angular/core';
import {StyledBaseComponent} from "../styled-base/styled-base.component";
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {User} from "../../interfaces/user";
import {Globals} from "../../shared/Globals";

@Component({
    selector: 'bst-user-picker',
    templateUrl: './user-picker.component.html',
    styleUrls: ['./user-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UserPickerComponent),
            multi: true
        }
    ],
    standalone: false
})
export class UserPickerComponent extends StyledBaseComponent implements ControlValueAccessor{

  control = new FormControl(null, []);

  constructor() {
    super();
  }

  // Function to call when the value changes.
  onChange = (value: User) => {};
  // Function to call when the input is touched (when a star is clicked).
  onTouched = () => {};

  ngOnInit(): void {
    // Without this, picks made via the inner list-adder never propagate to
    // the wrapping FormControl (writeValue only handles parent to child).
    this.subs.push(this.control.valueChanges.subscribe(v => this.onChange(v)));
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: User): void {
    this.control.setValue(value);
    this.onChange(this.value);
  }



  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  get value(): User|null{
    return this.control.value || null;
  }

  get logo() {
    return this.value?.logo && this.value?.logo.preview ? Globals.storage(this.value?.logo.preview) : this.value?.provider_avatar;
  }

  get name(){
    return this.value ? this.value.name_first + ' ' + this.value.name_last : null;
  }

}
